import { SALES_CHANNEL_NAME } from "../config/const";

const initialState = {
  name: undefined,
};

const salesChannelReducer = (state = initialState, action) => {
  switch (action.type) {
    case SALES_CHANNEL_NAME: {
      return { ...state, name: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default salesChannelReducer;



// WEBPACK FOOTER //
// ./src/reducers/salesChannelReducer.js